import styled from "styled-components";
import { theme } from "../../../styles";
import { TStyleConnotation, TStyleSize } from "../../../types";
import { Container } from "../../util";

interface ILogoStyle {
  $color?: TStyleConnotation;
  $height: number;
  $width: number;
  $size: TStyleSize;
}

export const LogoSvg = styled(Container)<ILogoStyle>`
  height: ${({ $height }) => `${$height}px;`};
  width: ${({ $width }) => `${$width}px;`};
`;

// The Mitti wordmark is much wider than the boxed SafetyCulture mark, so only
// height is constrained here — width scales to match the SVG's own aspect
// ratio instead of being squeezed into the SC mark's dimensions.
export const MittiWordmarkSvg = styled(Container)<{ $height: number }>`
  height: ${({ $height }) => `${$height}px;`};
  width: auto;
`;

interface IMittiLogoStyle {
  $color: TStyleConnotation;
  $height: number;
  $width: number;
}

export const MittiLogo = styled("svg")<IMittiLogoStyle>`
  ${({ $color }) => {
    switch ($color) {
      case "surface":
        return `
          fill: ${theme.color.surface.background.default.default};
        `;
      case "accent":
      default:
        return `
          fill: ${theme.color.accent.background.default.pressed};
        `;
    }
  }}
`;
